module.exports = "/_next/static/images/82c8f4aa10ebafd3a611399eecdb0e7e-robot-lg.png";